import { makeHead } from '@/root/components/shared/DayPicker/CustomWeekBar'

// Penpot "UI components / Calendar": weekday names Poppins 700 11px, not uppercased, no divider.
// `!` because react-day-picker's unlayered .rdp-head_cell beats Tailwind's layered utilities.
export const Head = makeHead(
  'text-neutral-medium-lighter translate-y-2 [&_th]:text-[11px]! [&_th]:font-bold [&_th]:normal-case!'
)
